const initState = {
    CAPA_PLAN:[]
};
  
  const ncoGraphicalDashboardReducer = (state = initState, action) => {
    switch (action.type) {
      case 'GET_BAR_CHART':
        return {
          ...state,
          CAPA_PLAN: action.data,
        };
  
      default:
        return state;
    }
  };
  
  export default ncoGraphicalDashboardReducer;
  